import ApplePodcastIcon from '@/components/pages/podcast/components/apple-podcast-icon';
import RSSIcon from '@/components/pages/podcast/components/rssicon';
import SpotifyIcon from '@/components/pages/podcast/components/spotify-icon';
import Podcast from '@/types/pages/api/podcasts/podcast';

type PodcastLayoutProps = {
    podcast: Podcast;
};

const SideBar = (props: PodcastLayoutProps) => {
    const { podcast } = props;

    return (
        <aside className="inline-flex flex-col items-start justify-start border-t-[1px] border-slate bg-white w-full">
            <div className="flex flex-col items-start justify-start w-full ">
                <div className="inline-flex items-center justify-start w-full px-4 sm:px-6 md:px-4 lg:px-8 xl:px-12 py-5 border-b-[1px] border-slate">
                    <p className="text-base font-halbfett tracking-widest font-semibold leading-none text-black uppercase">
                        follow
                    </p>
                </div>
                <div className="flex flex-col space-y-10 items-start justify-start w-full py-10 px-4 sm:px-6 md:px-4 lg:px-8 xl:px-12">
                    <ul
                        role="list"
                        className="flex lg:flex-col justify-center gap-10 text-base font-medium leading-7 text-slate-700 sm:gap-8 lg:gap-[40px]"
                    >
                        {[
                            ['Spotify', SpotifyIcon, podcast.spotifyIdentifier || ''],
                            ['Apple Podcast', ApplePodcastIcon, podcast.itunesIdentifier || ''],
                            ['RSS Feed', RSSIcon, podcast.feedUrl || ''],
                        ].map(([label, Icon, url]) =>
                            url ? (
                                <li key={label as string} className="flex">
                                    <a
                                        href={url as string}
                                        target="_blank"
                                        className="group flex items-center"
                                        aria-label={label as string}
                                        rel="noreferrer"
                                    >
                                        <span className="flex">
                                            {/* @ts-ignore */}
                                            <Icon className="h-8 w-8 fill-slate-400 group-hover:fill-slate-600" />
                                            <span className="hidden lg:ml-3 lg:block font-medium">
                                                <>{label as string}</>
                                            </span>
                                        </span>
                                    </a>
                                </li>
                            ) : null,
                        )}
                    </ul>
                </div>
            </div>
            {/*
            <div className="flex flex-col items-start justify-start w-full">
                <div className="inline-flex items-center justify-start w-full px-4 sm:px-6 md:px-4 lg:px-8 xl:px-12 py-5 border-y-[1px] border-slate">
                    <div className="flex items-center justify-start flex-1">
                        <p className="text-base font-halbfett tracking-widest font-semibold leading-none text-black uppercase">
                            hosts
                        </p>
                    </div>
                </div>
                <div className="flex flex-col space-y-10 items-start justify-start w-full py-10 px-4 sm:px-6 md:px-4 lg:px-8 xl:px-12">
                    <Author podcast={podcast} />
                    <Author podcast={podcast} />
                </div>
            </div>
            <div className="flex flex-col items-start justify-start w-full">
                <div className="inline-flex items-center justify-start w-full px-4 sm:px-6 md:px-4 lg:px-8 xl:px-12 py-5 border-y-[1px] border-slate">
                    <div className="flex items-center justify-start flex-1">
                        <p className="text-base font-halbfett tracking-widest font-semibold leading-none text-black uppercase">
                            sponsors
                        </p>
                    </div>
                </div>
                <div className="flex flex-col space-y-10 items-start justify-start w-full py-10 px-4 sm:px-6 md:px-4 lg:px-8 xl:px-12">
                    <Sponsor podcast={podcast} />
                    <Sponsor podcast={podcast} />
                </div>
            </div>
            */}
        </aside>
    );
};

export default SideBar;
